module.exports = __webpack_public_path__ + "static/media/avatar3.9c37d710.png";